module.exports = __webpack_public_path__ + "img/foot.73bb573c.png";